import { ILocalStorageServiceConfig } from './local.service.config';
import { Injectable, Inject } from '@angular/core';

export interface ILocalStorageService {
  set(key: string, object: any): void;
  get<T>(key: string): T;
  remove(key: string): void;
  clear(): void;
}

@Injectable()
export class LocalStorageService implements ILocalStorageService {

  private localStorage: Storage;

  constructor(@Inject('LOCAL_STORAGE_SERVICE_CONFIG') private config: ILocalStorageServiceConfig) {
    this.localStorage = window.localStorage;
  }

  public set(key: string, object: any): void {
    this.localStorage.setItem(this.keyGen(key), JSON.stringify(object));
  }

  public get<T>(key: string): T {
    return JSON.parse(this.localStorage.getItem(this.keyGen(key))) as T;
  }

  public remove(key: string): void {
    this.localStorage.removeItem(this.keyGen(key));
  }

  public clear(): void {
    this.localStorage.clear();
  }

  private keyGen(key: string): string {

    if (this.config.prefix.length < 5) { throw new RangeError('Local storage prefix length must be greater then 4.'); }

    return `${this.config.prefix}_${key}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/local.storage.service/local.storage.service.ts